import { timelineItems } from '@/mocks/home';

export default function TimelineSection() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-shell px-4 md:px-8">
        <div className="reveal max-w-2xl">
          <span className="flex items-center gap-2 font-label text-xs tracking-[0.3em] text-accent-700">
            <i className="ri-route-line text-[14px]" />
            TIMELINE
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            事件推进脉络
          </h2>
          <p className="mt-2 font-body text-sm text-foreground-600">
            单独看每一条线索都平平无奇，按时间串起来，因果就浮出来了。
          </p>
        </div>

        <ol className="mt-12 relative border-l border-background-200 pl-6 md:pl-10">
          {timelineItems.map((item) => (
            <li key={item.title} className="reveal relative pb-10 last:pb-0">
              <span className="absolute -left-[31px] top-1 flex h-4 w-4 items-center justify-center rounded-full border-2 border-background-50 bg-accent-500 md:-left-[47px]" />
              <span className="font-label text-[12px] tracking-wider text-accent-700">
                {item.time}
              </span>
              <h3 className="mt-1.5 font-heading text-[16.5px] font-semibold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 max-w-2xl font-body text-[13.5px] leading-relaxed text-foreground-600">
                {item.note}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}